import { IGoal } from "motw_core/Entity/IGoal";
import { IGoalDataPoint } from "motw_core/Entity/IGoalDataPoint";
import { ILogEntry } from "motw_core/Entity/ILogEntry";
import { EGoalDatapointType } from "motw_core/Goals/GoalDataPoints/EGoalDatapointType";
import { IsDatapointRelevant } from "motw_core/Goals/GoalDataPoints/IsDatapointRelevant";
import {
	IGoalWithDatapoints
} from "motw_core/Repositories/DatapointRepository";
import { GetAllLogEntriesAsync } from "motw_core/Repositories/LogRepository";
import * as React from "react";
import { GoalRateDisplay } from "source/app/presentation/MainPanel/Goals/GoalCards/RateDisplay/GoalRateDisplay";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import { RemoveDatapointAsync } from "../../../../../../services/EntityServices/DatapointService";
import { AreYouSure } from "../../../../../../services/Shared/RenderSwal/RenderSwal";
import Hyperlink from "../../../../../Shared/Link/Hyperlink";
import Render from "../../../../../Shared/Render";
import { Style } from "../../../../../Shared/Styles/CSS";
import Cell from "../../../../Dreams/Cell/Cell";
import * as styles from "./GoalDataPoints.css";
import moment from "moment";

export function GoalDataPoints({
    goal,
    type,
}: {
    goal: IGoalWithDatapoints;
    type: EGoalDatapointType;
}) {
    const { datapoints } = goal;

    return (
        <div className={styles.container}>
            <Render id="hasGoalDatapoints" when={datapoints.length > 0}>
                {datapoints.map((datapoint, index) => {
                    const isDatapointRelevant = IsDatapointRelevant(
                        datapoint,
                        goal.startdate
                    );

                    return (
                        <div
                            key={index}
                            {...Style(`goalDatapoint_${isDatapointRelevant}`, {
                                opacity: isDatapointRelevant ? 1.0 : 0.5,
                            })}
                        >
                            <Cell>
                                {moment(datapoint.lastmodifiedtime).format(
                                    "YYYY-MM-DD"
                                )}
                            </Cell>
                            <GoalRate
                                weeklyRate={datapoint.value}
                                type={type}
                            />
                            <Cell>{datapoint.comment}</Cell>
                            <Cell>
                                <Hyperlink
                                    whenClicked={() =>
                                        DeleteDatapointFromFormAsync(
                                            goal,
                                            datapoint
                                        )
                                    }
                                >
                                    <Glyphicon icon={EGlyphicon["minus"]} />
                                </Hyperlink>
                            </Cell>
                        </div>
                    );
                })}
            </Render>
            <Render
                id="noGoalDatapoints"
                when={!datapoints.length}
                withClasses={styles.noGoalDatapoints}
            >
                No data for this goal yet!
            </Render>
        </div>
    );
}

export default GoalDataPoints;

export async function DeleteDatapointFromFormAsync(
    goal: IGoal,
    datapoint: IGoalDataPoint
) {
    const logEntries: ILogEntry[] = await GetAllLogEntriesAsync(
        ClientDataProvider
    );

    const connectedLogEntry: ILogEntry = logEntries.filter(
        (entry) => entry.goaldatapointid === datapoint.id
    )[0];

    AreYouSure(
        `Are you sure? This will also delete the log entry: ${JSON.stringify(
            connectedLogEntry
        )}`,
        async () =>
            await RemoveDatapointAsync(goal, connectedLogEntry, datapoint)
    );
}

function GoalRate({
    weeklyRate,
    type,
}: {
    weeklyRate: number;
    type: EGoalDatapointType;
}) {
    return (
        <span>
            <Render id="" when={type === EGoalDatapointType.GoalDatapoint}>
                <Cell>{weeklyRate}</Cell>
            </Render>
            <Render id="" when={type === EGoalDatapointType.WeeklyRateChange}>
                <GoalRateDisplay weeklyRate={weeklyRate} />
            </Render>
        </span>
    );
}
